module.exports = __webpack_public_path__ + "media/SMID-intro2.9105dd57.mp4";